const ERROR_PHRASES = {
    ERROR_OCCURRED_PLEASE_TRY_AGAIN: 1008,
    REQUESTED_FILE_NOT_FOUND: 3605,
} as const;

export const RESPONSE_ERROR_PHRASES = {
    //unknown
    NOT_FOUND: ERROR_PHRASES.ERROR_OCCURRED_PLEASE_TRY_AGAIN,
    PAGE_NOT_FOUND: 16043,
    PAGE_NOT_FOUND_DESCRIPTION: 16044,
    UNAUTHORISED: 3603,
    FORBIDDEN: 16055,
    ACCESS_DENIED: 3602,
    ACCESS_DENIED_DESCRIPTION: 16055,
    SERVER_ERROR: ERROR_PHRASES.ERROR_OCCURRED_PLEASE_TRY_AGAIN,
    UNAVAILABLE: ERROR_PHRASES.ERROR_OCCURRED_PLEASE_TRY_AGAIN,
    UNKNOWN: ERROR_PHRASES.ERROR_OCCURRED_PLEASE_TRY_AGAIN,
    BAD_REQUEST: ERROR_PHRASES.ERROR_OCCURRED_PLEASE_TRY_AGAIN,
    UNABLE_TO_PROCESS: 3483,
    SOMETHING_WRONG: 16056,
    SOMETHING_WRONG_DESCRIPTION: 16057,
    RETRY_BUTTON: 16065,
} as const;

export const LOGIN_ERROR_PHRASES = {
    CODE_SENT_RECENTLY: 15953,
    INVALID_CAPTCHA_RESPONSE: 261,
    MISSING_PARAMETERS: 15689,
    BAD_PASS_RESET_LINK: 3559,
    CODE_NOT_FOUND: 15693,
    CODE_INVALID: 15694,
    WRONG_CODE: 15959,
    INVALID_PASSWORD: 15695,
    ACCESS_DENIED: 3602,
    RECAPTCHA_KEY_MISSING: 1008,
    INVALID_PHONE_NUMBER_FOR_COUNTRY_CODE: 15961,
    LOGIN_COOKIE_PROBLEM: 18912,
    SOMETHING_WRONG_RETURN_TO_LOGIN: 19033,
} as const;

export const FORM_ERROR_PHRASES = {
    REQUIRED_FIELD: 966,
    ENTER_VALID_EMAIL: 354,
    ENTER_VALID_PHONE: 2161,
    MUST_BE_A_NUMBER: 16001,
} as const;

export const GENERAL_ERROR_PHRASES = {
    ERROR_BOUNDARY: 1008,
};
